/**
 * Week-anchor arithmetic for coaching plans: where a Monday-anchored week
 * starts.
 *
 * Split out from `planning-service.ts` so the read-path week materialization can
 * share it without importing that module's database and delivery wiring. Pure --
 * no database access, no clock.
 */

export function addUtcDays(date: Date, days: number): Date {
  return new Date(
    Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate() + days,
    ),
  )
}

/** `date-fns`-style weekday index for the Monday anchor. */
const MONDAY_WEEK_START_INDEX = 1

/** Weekend days get the lighter default allowance. */
const WEEKEND_BUDGET_MINUTES = 120
const WEEKDAY_BUDGET_MINUTES = 180

/**
 * The budget a freshly created plan day starts with. Shared by `addWeek`
 * and the read-path materializer so the two cannot drift -- the weekend rule
 * lived as a bare `120 : 180` literal in each of them.
 */
export function defaultBudgetMinutes(dayDate: Date): number {
  return [0, 6].includes(dayDate.getUTCDay())
    ? WEEKEND_BUDGET_MINUTES
    : WEEKDAY_BUDGET_MINUTES
}

/** The Monday-aligned week start on or before `date`. */
export function alignedWeekStart(date: Date): Date {
  const offset = (date.getUTCDay() - MONDAY_WEEK_START_INDEX + 7) % 7
  return addUtcDays(date, -offset)
}
